export default __webpack_public_path__ + "static/media/Border (2).31ea3ab9.svg";